<!-- 海报 -->
<template>
  <div class="posters-father">
    <el-button
      type="primary"
      class="upload-button"
      :disabled="img_list.length >= maxCount"
      title="点击上传"
    >
      <label for="home-list" style="">
        <slot></slot>
        <input
          type="file"
          :disabled="img_list.length >= maxCount"
          @change="uploadImg"
          id="home-list"
          style=""
        />
      </label>
    </el-button>
    <div
      :style="
        'width:' +
          width +
          'px;height:160px;margin-left:180px;scrollbar-width:none;'
      "
    >
      <el-scrollbar
        wrapStyle="overflow-x:hidden;"
        style="width:100%;height:160px;scrollbar-width:none;"
      >
        <div
          style="width:300%;height:160px;scrollbar-width:none;scrollbar-width:none;"
        >
          <div
            v-for="(item, index) in img_list"
            :key="index"
            class="img-list-father"
          >
            <div style="position:relative;">
              <div class="file-item">
                <img width="100%" :src="item" alt="" style="" />
              </div>
              <div
                class="close"
                @click="close(index, 'img_list')"
                style="color:#fff;"
              >
                ✗
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
export default {
  name: "posters",
  data() {
    return {
      img_list: [],
      width: document.body.clientWidth - 460
    };
  },
  watch: {
    img_list: {
      handler(newList, oldList) {
        if (newList.length >= this.maxCount) {
          this.warnMessage("最多可上传" + this.maxCount + "张照片");
        }
      },
      immediate: true
    }
  },
  props: {
    maxCount: Number
  },
  mounted() {
    // console.log(this.width);
  },
  methods: {
    uploadImg(e) {
      var that = this;
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = function() {
        that.img_list.unshift(reader.result);
        that.$emit("rImgList", that.img_list);
      };
    },
    close(index, list) {
      this[list].splice(index, 1);
      this.$emit("rImgList", this.img_list);
    },
    checked() {
      alert("aaaaaaaaaaaaaaa");
    }
  }
};
</script>
<style scoped>
.posters-father {
  position: relative;
  width: 98%;
  height: 170px;
  padding: 5px;
}
img {
  width: 375px;
  height: 150px;
}
.upload-button {
  position: absolute;
  left: 20px;
  display: inline-block;
  width: 150px;
  height: 150px;
  cursor: pointer;
}
#home-list {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.file-item {
  display: inline-block;
}
.close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 24px;
  color: #fff;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 1.2;
  background-color: red;
  z-index: 100;
  cursor: pointer;
}
.img-list-father {
  display: inline-block;
  margin-left: 10px;
  scrollbar-width: none;
}
</style>
